import { useQuery } from "@apollo/client";
import { useAuth } from "@frontegg/react";
import { GET_USER } from "graphql/user";
import CardHolderType from "enums/CardHolderType";

/** True when the business holds the company's cards, so nobody needs a personal cardholder. */
export const useBusinessCardholders = (): boolean => {
  const { user } = useAuth();
  const { data } = useQuery(GET_USER, {
    variables: { userId: user?.id },
    skip: !user?.id,
  });
  return data?.user?.company?.cardHolderType === CardHolderType.BUSINESS;
};
